export default __webpack_public_path__ + "static/pragicts-ai-banner-at-you-finger-tips-24effaaaf295ba925ee822321c4d77a8.jpg";